import { TextField } from '@mui/material';
import { useIsSupplierPortalProductEditorFieldDisabled } from 'hooks/useUserState_utils';

import { isYoutubeLink } from 'helpers/ValidationPatterns';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const YoutubeVideoField: React.FC = () => {
  const { t } = useTranslation();
  const { register, watch } = useFormContext();

  const url = watch('private_attributes.data.video');
  const isValidUrl = () => isYoutubeLink.test(url) || !url;
  const disabled = useIsSupplierPortalProductEditorFieldDisabled();

  return (
    <TextField
      label={`${t('forms.product.video.label')} URL`}
      fullWidth
      margin="normal"
      error={!isValidUrl()}
      helperText={
        !isValidUrl()
          ? `Please enter a valid ${t(
              'forms.product.video.label'
            )} url Example: https://www.youtube.com/watch?v=82z6RpPEPpA or https://youtu.be/4-ozPMm8Ljk !`
          : undefined
      }
      {...register('private_attributes.data.video')}
      disabled={disabled}
    />
  );
};
